var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg25",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "g18",
  clipPath: "url(#clip0_259_10492)",
  transform: "translate(-.05 -.02)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_259_10492",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path2",
  fill: "#fff",
  d: "M16 0H0v16h16z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g16",
  mask: "url(#mask0_259_10492)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask1_259_10492",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path5",
  fill: "#fff",
  d: "M16 0H0v16h16z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g14",
  mask: "url(#mask1_259_10492)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path8",
  fill: "#f70",
  d: "M.05 7.66c0-3.6 0-5.41 1.11-6.53C2.3.02 4.1.02 7.7.02h.64c3.6 0 5.4 0 6.52 1.1 1.12 1.12 1.12 2.94 1.12 6.54v.64c0 3.6 0 5.4-1.12 6.52-1.1 1.12-2.92 1.12-6.52 1.12H7.7c-3.6 0-5.41 0-6.53-1.12S.05 11.9.05 8.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path10",
  fill: "#fff",
  d: "M8 7.94a2.8 2.8 0 1 0 0-5.62 2.8 2.8 0 0 0 0 5.62m-.89-3.72a1.28 1.28 0 1 1 1.81 1.8 1.28 1.28 0 1 1-1.8-1.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path12",
  fill: "#fff",
  d: "m11.8 9.07-.82-1.13a.13.13 0 0 0-.2-.01A4.28 4.28 0 0 1 8 9.03a4.3 4.3 0 0 1-2.77-1.1.15.15 0 0 0-.2.01l-.82 1.13a.13.13 0 0 0 .01.18c.7.56 1.5.94 2.35 1.14l-1.75 3.07c-.04.1.02.2.12.2h1.7c.06 0 .1-.03.12-.08l1.22-2.72 1.21 2.72c.02.04.07.08.12.08h1.7c.1 0 .17-.1.12-.2L9.39 10.4c.84-.2 1.65-.57 2.35-1.14.1-.05.1-.12.06-.18z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "defs23"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_259_10492"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect20",
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgOk;